import { AbstractControl } from '@angular/forms';

export const controlHasAnyError = (control: AbstractControl): boolean => (control.errors ? true : false);

export const controlHasError = (control: AbstractControl, error: string): boolean =>
	control.errors[error] ? true : false;
